
import listArrange from '@/components/temporary/list-arrange'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
import Badge from 'vux/src/components/badge/index.vue'


export default {
name: "received-arrivalTp",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
props: ['data'],
created() {
let templateData = this.data;
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQueryV2,
data() {
return {
title: [templateData.orderNo, templateData.poItemNo],
desc: [templateData.asn&&templateData.asn.supplier?templateData.asn.supplier.supplierName: templateData.asn.supplierName]
}
}
},
this.listArrange = [
{
icon: "fa fa-file-text-o font-size-mr",
span: 21,
templateBoard: {
template: "<span class=\"black\">{{materialName}}</span>",
data() {
return {
materialName: templateData.matName
}
},
components: {
divSpan
}
}
},
{
span: 3,
templateBoard: {
template: "<span>x{{delQty}}</span>",
data() {
return {
delQty: templateData.delQty
}
},
}
}
],
this.approvalTemplateBoard = {
template: listHeaderTemplate.asnStatus,
data() {
return {
status: templateData.asn?templateData.asn.status:""
}
},
components: {
Badge
}
}
},
methods: {},
components: {
listArrange,
divSpan,
listHeaderTemplate
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/received-arrivalTp.vue